// Shared breakpoint configuration
export const BREAKPOINTS = {
  xs: 420,
  sm: 576,
  md: 768,
  lg: 992,
  // 840 is used from payflow.scss as max width, so we add 1px to ensure ">=" behavior
  mdWide: 841,
  xl: 1200,
  xxl: 1440,
} as const;

export const BREAKPOINTS_PX = {
  xs: `${BREAKPOINTS.xs}px`,
  sm: `${BREAKPOINTS.sm}px`,
  md: `${BREAKPOINTS.md}px`,
  mdWide: `${BREAKPOINTS.mdWide}px`,
  lg: `${BREAKPOINTS.lg}px`,
  xl: `${BREAKPOINTS.xl}px`,
  xxl: `${BREAKPOINTS.xxl}px`,
} as const;

export const BREAKPOINT_MINS = {
  xs: BREAKPOINTS.xs,
  sm: BREAKPOINTS.sm,
  md: BREAKPOINTS.md,
  mdWide: BREAKPOINTS.mdWide,
  lg: BREAKPOINTS.lg,
  xl: BREAKPOINTS.xl,
  xxl: BREAKPOINTS.xxl,
} as const;

export const BREAKPOINT_MAXS = {
  xs: BREAKPOINTS.xs - 1,
  sm: BREAKPOINTS.sm - 1,
  md: BREAKPOINTS.md - 1,
  mdWide: BREAKPOINTS.mdWide - 1,
  lg: BREAKPOINTS.lg - 1,
  xl: BREAKPOINTS.xl - 1,
  xxl: BREAKPOINTS.xxl - 1,
} as const;

// Type for breakpoint keys
export type BreakpointKey = keyof typeof BREAKPOINTS;

// Utility function to get breakpoint value
export const getBreakpointValue = (key: BreakpointKey): number => BREAKPOINTS[key];

// Utility function to get breakpoint value as px string
export const getBreakpointValueInPx = (key: BreakpointKey): string => BREAKPOINTS_PX[key];
